import { render } from "./EvaluateQuotaActivationRule.vue?vue&type=template&id=7ca563f8&scoped=true"
import script from "./EvaluateQuotaActivationRule.vue?vue&type=script&lang=js"
export * from "./EvaluateQuotaActivationRule.vue?vue&type=script&lang=js"

import "./EvaluateQuotaActivationRule.vue?vue&type=style&index=0&id=7ca563f8&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca563f8"]])

export default __exports__